<nav class="navbar shadow-sm">
  <!-- Logo -->
  <div class="logo d-flex align-items-center" (click)="navigateHome()">
    <span class="logo-icon"><img src="logo_no_background.png" width="50px" height="50px" /></span>
    <span class="logo-text ms-2">Medvisit</span>
  </div>

  @if (clinicName) {
  <div class="authenticated-clinic-name d-none d-md-flex" title="Active practice">
    <i class="bi bi-hospital-fill"></i>
    <span class="text-truncate">{{ clinicName }}</span>
  </div>
  }

  <!-- Mobile toggle -->
  <button class="menu-toggle" (click)="toggleMenu()">☰</button>

  <!-- Dynamic nav links -->
  <ul class="nav-links" [class.open]="isMenuOpen">
    @if (clinicName) {
    <li class="authenticated-clinic-name-mobile d-md-none">
      <i class="bi bi-hospital-fill"></i>
      <span class="text-truncate">{{ clinicName }}</span>
    </li>
    }

    <!-- Role context switcher (only when user has more than 1 role) -->
    @if (contextRoles.length > 1) {
    <li class="nav-dropdown" [class.open]="isExpanded('__role_switcher__')">
      <span class="nav-dropdown-toggle" (click)="toggleExpand('__role_switcher__')">
        <i class="bi bi-person-badge me-1"></i> Switch Role
        <i class="bi bi-chevron-down dropdown-arrow"></i>
      </span>
      <ul class="dropdown-menu-list">
        @for (role of contextRoles; track role) {
        <li>
          <a (click)="switchRole(role); isMenuOpen = false" style="cursor: pointer"
            [class.role-active]="role === activeRole">
            {{ role | titlecase }}
            @if (role === activeRole) {
            <i class="bi bi-check2 ms-1"></i>
            }
          </a>
        </li>
        }
      </ul>
    </li>
    }

    @for (item of menuItems; track item.label) {
    <!-- Hide team chat when doctor is not linked to any clinic -->
    @if (item.route !== '/dashboard/staff-chat' || isLinkedToClinic) {
    <!-- Item with children (dropdown) -->
    @if (item.children && item.children.length > 0) {
    <li class="nav-dropdown" [class.open]="isExpanded(item.label)">
      <span class="nav-dropdown-toggle" (click)="toggleExpand(item.label)">
        @if (item.icon) {
        <i class="bi {{ item.icon }} me-1"></i>
        }
        {{ item.label }}
        <i class="bi bi-chevron-down dropdown-arrow"></i>
      </span>
      <ul class="dropdown-menu-list">
        @for (child of item.children; track child.label) {
        <li>
          <a [routerLink]="child.route" routerLinkActive="active" (click)="isMenuOpen = false">
            @if (child.icon) {
            <i class="bi {{ child.icon }} me-1"></i>
            }
            {{ child.label }}
          </a>
        </li>
        }
      </ul>
    </li>

    <!-- Leaf item -->
    } @else {
    <li>
      @if (item.route === '/dashboard/staff-chat' && !isClinicActive) {
      <span class="nav-link disabled text-muted" style="cursor: default; opacity: 0.5"
        title="Not available until practice is active">
        @if (item.icon) {
        <i class="bi {{ item.icon }} me-1"></i>
        }
        {{ item.label }}
      </span>
      } @else {
      <a [routerLink]="item.route" routerLinkActive="active" (click)="isMenuOpen = false" class="position-relative">
        @if (item.icon) {
        <i class="bi {{ item.icon }} me-1"></i>
        }
        {{ item.label }}
        @if (item.route === '/dashboard/staff-chat' && chatUnreadCount > 0) {
        <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
          style="font-size: 0.6rem">
          {{ chatUnreadCount > 99 ? '99+' : chatUnreadCount }}
        </span>
        }
      </a>
      }
    </li>
    }
    }
    }
    <!-- end clinic-guard for staff-chat -->

    <!-- Logout always visible -->
    <li>
      <a (click)="logout()" style="cursor: pointer">
        <i class="bi bi-box-arrow-right me-1"></i> Logout
      </a>
    </li>
  </ul>
</nav>

<main class="content">
  <router-outlet></router-outlet>
</main>